// extracted by mini-css-extract-plugin
export default {"cls1":"NGPZSzb6lAtRS5nzrJN5","cls2":"ExCOGTDkiZED5EGtsJ3r NGPZSzb6lAtRS5nzrJN5","isPhone":"DOe8RzIG8C22H444B0Y1"};